import type { ShouldRevalidateFunction } from 'react-router';

/**
 * Pill selection, sort and pagination all live in the URL, so every GET has to
 * re-run the loader. The parent `_app` route blocks GET revalidation, so the
 * view routes opt back in — form actions still skip it.
 */
export const imageLabelShouldRevalidate: ShouldRevalidateFunction = ({
    formAction,
}) => !formAction;
